import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { checkAdminSession } from "../lib/articlesApi";

export function RequireAdminSession({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    checkAdminSession()
      .then((ok) => {
        if (!cancelled) setAuthenticated(ok);
      })
      .catch(() => {
        if (!cancelled) setAuthenticated(false);
      })
      .finally(() => {
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <main className="min-h-screen bg-[#faf9f7] pt-36 px-6">
        <p className="text-slate-500">Validando sessão...</p>
      </main>
    );
  }

  if (!authenticated) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
